import { useContext, useEffect, useState } from "react";
import {
  BlockToolTip,
  ClickMaxAmount,
  ClickMaxAmountInner,
  ContentToolTip,
  SwapChoose,
  SwapChooseDefault,
  SwapContent,
  SwapDetail,
  SwapDetailBlock,
  SwapDetailRow,
  SwapExchangeIcon,
  SwapInput,
  SwapInputAsset,
  SwapInputTitle,
  SwapInputWrapper,
} from "../../Swap/styled";
import { ContextProviderWrapper } from "../../../../components/Context";
import icnToolTip from "../../../../assets/Dashboard/Common/icn_tooltip.svg";
import swap_exchange from "../../../../assets/Dashboard/Swap/swap_exchange.png";
import { useSelector } from "react-redux";
import { ButtonCommon } from "../../../../Layout/styled";
import ModalOverlay from "../../../../components/Common/ModalOverlay";
import ChooseToken from "../../Swap/ChooseToken";
import default_token_image from "../../../../assets/Dashboard/Common/default-token-image.png";
import {
  convertFixed,
} from "../../../../utils/convertFormatNumber";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { Controller, useForm } from "react-hook-form";
import InputCommon from "../../../../components/Common/Input";
import handleCheckPair from "../../../../utils/checkPair";
import getBalance from "../../../../utils/getBalance";
import getRatio from "../../../../utils/RatioX_Y";
import PreAddLpV1 from "../../../../utils/prePareAddLp";

const FormAddLp = () => {
  const { isMobile, theme } = useContext(ContextProviderWrapper)!;
  const { listTokens }: any = useSelector((state: any) => state.pool);
  const [openModal, setOpenModal] = useState(false);
  const [tokenX, setTokenX]: any = useState({});
  const [tokenY, setTokenY]: any = useState({});
  const [typeModal, setTypeModal]: any = useState(true);
  const { open } = useAppKit();
  const { address }: any = useAppKitAccount();
  const [loading, setLoading] = useState(false);
  const [amountX, setAmountX]: any = useState("");
  const [amountY, setAmountY] = useState(0);
  const { setValue, control } = useForm({ mode: "onChange" });
  const [isPair, setIsPair]: any = useState("");
  const [x_balance, setX_balance] = useState();
  const [y_balance, setY_balance] = useState();
  const [ratio, setRatio] = useState(0);
  console.log("tokenX", tokenX);
  console.log("tokenY", tokenY);
  useEffect(() => {
    const handleCallRpc = async () => {
      if (address) {
        if (tokenX?.address) {
          const X: any = await getBalance(
            address,
            tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
              ? ""
              : tokenX?.address
          );
          setX_balance(X || 0);
        }
        if (tokenY?.address) {
          const X: any = await getBalance(
            address,
            tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
              ? ""
              : tokenY?.address
          );
          setY_balance(X || 0);
        }
      }
      if (tokenX?.address && tokenY?.address) {
        const Pair: any = await handleCheckPair(
          tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
            : tokenX?.address,
          tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
            : tokenY?.address
        );
        console.log("Pair", Pair);

        if (Pair !== "0x0000000000000000000000000000000000000000") {
          setIsPair(Pair);
        }
      }
    };
    handleCallRpc();
  }, [tokenX, tokenY, address]);
  useEffect(() => {
    if (amountX && ratio && isPair) {
      const amount = Number(amountX) * ratio;
      setAmountY(Math.ceil(amount * 1000) / 1000);
    } else {
      setAmountY(0);
    }
  }, [amountX, ratio, isPair]);
  useEffect(() => {
    if (amountY && ratio && isPair) {
      const amount = Number(amountY) / ratio;
      setAmountX(Math.ceil(amount * 1000) / 1000);
    } else {
      setAmountX(0);
    }
  }, [ratio, isPair]);
  useEffect(() => {
    if (isPair) {
      const handleGetRatio = async () => {
        const Result = await getRatio(
          isPair,
          tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
            : tokenX?.address,
          tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
            : tokenY?.address
        );
        setRatio(Result || 0);
      };
      handleGetRatio();
    }
  }, [isPair]);
  const handleSubmit = async () => {
    setLoading(true);
    await PreAddLpV1(
      tokenX?.address,
      tokenY?.address,
      Number(amountX) * Number(10 ** tokenX?.decimals),
      Number(amountY) * Number(10 ** tokenY?.decimals),
      address,
      0.1,
      Number(amountX),
      Number(amountY)
    );
    setLoading(false);
  };

  return (
    <>
      <SwapContent>
        <SwapInput className={`exchange ${theme}`}>
          <SwapInputTitle className={theme}>
            <SwapInputAsset>
              Asset <span className="font-DMMono">1</span>
            </SwapInputAsset>
            <ClickMaxAmount>
              {!isMobile && "Balance:"}
              {convertFixed(
                Number(x_balance) / Number(10 ** tokenX?.decimals) || 0
              )}{" "}
              |{" "}
              <span
                onClick={() => {
                  setAmountX(
                    Number(x_balance) / Number(10 ** tokenX?.decimals)
                  );
                }}
              >
                MAX
              </span>
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper className={theme} active={false}>
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenModal(true);
                setTypeModal(true);
              }}
            >
              <SwapChooseDefault className={theme}>
                <img
                  src={tokenX?.img || default_token_image}
                  alt="icon"
                  onError={(e) => (e.currentTarget.src = default_token_image)}
                />
                <p>{tokenX?.symbol}</p>
              </SwapChooseDefault>
            </SwapChoose>
            <Controller
              name="token0"
              control={control}
              render={({ field }: any) => (
                <InputCommon
                  {...field}
                  disabled={
                    !address ||
                    Number(x_balance) / Number(10 ** tokenX?.decimals) === 0
                      ? true
                      : false
                  }
                  value={amountX}
                  onChange={(e: any) => {
                    setAmountX(e.target.value);
                  }}
                  // onFocus={handleResetValueFrom}
                  placeHolder={"0"}
                />
              )}
            />
          </SwapInputWrapper>
        </SwapInput>
        <SwapExchangeIcon className={theme} onClick={async () => {}}>
          <img src={swap_exchange} alt="exchange" />
        </SwapExchangeIcon>
        <SwapInput className={theme}>
          <SwapInputTitle>
            <SwapInputAsset>
              Asset <span className="font-DMMono">2</span>
            </SwapInputAsset>
            <ClickMaxAmount>
              <ClickMaxAmountInner>
                {!isMobile && "Balance:"}{" "}
                {convertFixed(
                  Number(y_balance) / Number(10 ** tokenY?.decimals) || 0
                )}{" "}
                |
              </ClickMaxAmountInner>
              <span
                onClick={() => {
                  setAmountY(
                    Number(y_balance) / Number(10 ** tokenY?.decimals)
                  );
                }}
              >
                MAX
              </span>
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper className={theme} style={{}} active={1 > 0}>
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenModal(true);
                setTypeModal(false);
              }}
            >
              <SwapChooseDefault className={theme}>
                <img
                  src={tokenY?.img || default_token_image}
                  alt="icon"
                  onError={(e) => (e.currentTarget.src = default_token_image)}
                />
                <p>{tokenY?.symbol}</p>
              </SwapChooseDefault>
            </SwapChoose>
            {/* <p className="TextBoxTokenX">{Number(amountY)?.toFixed(2) || 0}</p> */}
            <Controller
              name="token1"
              control={control}
              render={({ field }: any) => (
                <InputCommon
                  {...field}
                  disabled={true}
                  value={amountY}
                  onChange={(e: any) => {
                    setAmountY(e.target.value);
                  }}
                  // onFocus={handleResetValueFrom}
                  placeHolder={"0"}
                />
              )}
            />
          </SwapInputWrapper>
        </SwapInput>
        <SwapDetail
          style={{
            marginBottom: "20px",
            overflow: "unset",
          }}
        >
          <SwapDetailBlock>
            <SwapDetailRow className={theme}>
              <p>
                APR <span className="font-DMMono">24h</span>
                <BlockToolTip className={theme}>
                  <span className="icn-tooltip">
                    <img src={icnToolTip} width={15} alt="Tooltip" />
                  </span>
                  <ContentToolTip>
                    <p>Annual percentage rate for 24 hours</p>
                  </ContentToolTip>
                </BlockToolTip>
              </p>
              <p>{`${0.0}%`}</p>
            </SwapDetailRow>
            <SwapDetailRow className={theme}>
              <p>Slippage:</p>
              <p>{0}%</p>
            </SwapDetailRow>
            <SwapDetailRow className={theme}>
              <p>
                Min. receive
                <BlockToolTip className={theme}>
                  <span className="icn-tooltip">
                    <img src={icnToolTip} width={15} alt="Tooltip" />
                  </span>
                  <ContentToolTip>
                    <p>
                      Your transaction will revert if there is a large,
                      unfavorable price movement before it is confirmed
                    </p>
                  </ContentToolTip>
                </BlockToolTip>
              </p>
              <p>
                {/* {convertFixed(
                      Number(Coins.fromNano(minExpectedTokens, 9).toString())
                    )} */}
              </p>
            </SwapDetailRow>
            <SwapDetailRow className={theme}>
              <p>Blockchain fee:</p>
              <p>0.26-0.6 TON</p>
            </SwapDetailRow>
            <SwapDetailRow className={theme}>
              <p>Estimated share of pool:</p>
              <p>+{`${0}%`}</p>
            </SwapDetailRow>
          </SwapDetailBlock>
        </SwapDetail>
        <>
          <ButtonCommon
            onClick={() => {
              !address ? open() : handleSubmit();
            }}
          >
            <>
              {address
                ? isPair
                  ? `Add Liquidity`
                  : "Create Paird"
                : "Connect Wallet"}
            </>
          </ButtonCommon>
        </>
      </SwapContent>
      <ModalOverlay
        component={
          <ChooseToken
            isFromModal={true}
            otherCurrentAssetKey={""}
            setCurrentAsset={(e: any) => {
              typeModal
                ? setTokenX(listTokens.find((item: any) => item.address === e))
                : setTokenY(listTokens.find((item: any) => item.address === e));
            }}
            setOtherCurrentAsset={setTokenY}
            setOpenFromModal={setOpenModal}
            setAmountFrom={() => {}}
            setAmountTo={() => {}}
            isLiq={true}
            isModal={1}
            setListFavorite={[]}
            listFavorite={[]}
          />
        }
        open={openModal}
        setOpen={setOpenModal}
        title={"Select a token"}
        width="400px"
      />
    </>
  );
};
export default FormAddLp;
